import tw, { styled } from 'twin.macro';

const fontFamily = 'Circular Std';

export const SignatureWrapper = styled.div`
  &.side-by-side {
    ${tw`flex flex-col items-start`}
    flex: 0 0 70%;
  }
`;

export const CanvasWrapper = styled.div`
  ${tw`mt-2 mb-3 flex`}
  height: ${({ height }) => height > 0 && `${height}px`};
  width: ${({ width }) => width > 0 && `${width}%`};
  pointer-events: ${({ disabled }) => disabled && 'none'};

  & canvas {
    ${tw`border border-solid border-fieldGray rounded bg-white`};
  }
`;

export const ButtonWrapper = styled.div`
  ${tw`flex gap-1.5 text-right items-center justify-end`}

  > button {
    ${tw`py-1.5 px-6 font-medium text-sm rounded outline-none cursor-not-allowed bg-white`}
    font-family: ${fontFamily} !important;
    border: 1px solid;
    transition: 200ms ease-in-out;
    filter: brightness(1);

    &.not-in-builder {
      cursor: pointer;
      font-family: var(--formFontType) !important;
    }

    &.clear {
      color: var(--btn-color, #fff);
      border-color: var(--btn-bag, #888);
      background-color: var(--btn-bag, #888);
    }

    &.accept {
      color: var(--btn-color, #fff);
      border-color: var(--btn-bag, #00afc4);
      background-color: var(--btn-bag, #00afc4);
    }

    :hover {
      filter: brightness(0.9);
    }
  }
`;

export const ViewSignatureWrapper = styled.div`
  ${tw`w-full h-full`}

  & > img {
    ${tw`w-full h-full`}
  }
`;
